import Placeholder from './placeholder'
import PropTypes from 'prop-types'
import React from 'react'
import Box from './box'

class Trunk extends React.PureComponent {

  static propTypes = {
    active: PropTypes.string,
    answer: PropTypes.string,
    boxes: PropTypes.array,
    blocks: PropTypes.array,
    details: PropTypes.string,
    editable: PropTypes.bool,
    expanded: PropTypes.array,
    fields: PropTypes.array,
    parent: PropTypes.string,
    hovering: PropTypes.object,
    onAddStep: PropTypes.func,
    onDetails: PropTypes.func,
    onEditStep: PropTypes.func,
    onExpandStep: PropTypes.func,
    onHover: PropTypes.func,
    onNewStep: PropTypes.func,
    onRemoveStep: PropTypes.func
  }

  render() {
    const { answer, parent } = this.props
    const boxes = this.props.boxes || []
    return (
      <div className="flowchart-segments">
        { boxes.map((box, index) => (
          <Box { ...this._getBox(box, index) } key={`box_${index}`} />
        )) }
        { (parent !== null || answer !== null) &&
          <Placeholder { ...this._getPlaceholder(boxes.length) } />
        }
      </div>
    )
  }

  _getBox(box, delta) {
    const { active, answer, blocks, details, editable, expanded, fields, hovering, parent, onAddStep, onDetails, onEditStep, onExpandStep, onHover, onNewStep, onRemoveStep } = this.props
    return {
      answer,
      box,
      active,
      blocks,
      delta,
      details,
      editable,
      expanded,
      fields,
      parent,
      hovering,
      onAddStep,
      onDetails,
      onEditStep,
      onExpandStep,
      onHover,
      onNewStep,
      onRemoveStep
    }
  }

  _getPlaceholder(delta) {
    const { answer, blocks, editable, hovering, parent, onAddStep, onNewStep, onHover } = this.props
    return {
      answer,
      blocks,
      delta,
      editable,
      hovering,
      parent,
      onAddStep,
      onNewStep,
      onHover
    }
  }

}

export default Trunk
